// extracted by mini-css-extract-plugin
module.exports = {"additionInfo":"PaymentPageContent_additionInfo__gYG4l"};